import * as React from "react";
import { memo } from "react";
const SvgCheckedCheckbox = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: 23,
      height: 23,
      x: 0.5,
      y: 0.5,
      fill: "#F68A1F",
      stroke: "#828282",
      rx: 3.5
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "85f5ad8f-9d98-4a42-a211-d834bcdface0-a",
      width: 24,
      height: 24,
      x: 0,
      y: 0,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "alpha"
      }
    },
    /* @__PURE__ */ React.createElement("path", { fill: "#C4C4C4", d: "M0 0h24v24H0z" })
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#85f5ad8f-9d98-4a42-a211-d834bcdface0-a)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10.39 15.28a1 1 0 0 0 1.41 0l5.66-5.66a1 1 0 0 0-1.41-1.41l-4.95 4.95-2.48-2.48a1 1 0 0 0-1.41 1.42z",
      clipRule: "evenodd"
    }
  ))
);
const Memo = memo(SvgCheckedCheckbox);
export default Memo;
